export default __webpack_public_path__ + "images/ec3fd238e486dc040272d148f5d86f86-medieval.jpg";